module.exports = __webpack_public_path__ + "static/img/davis_profile_800x621.a0612b3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/davis_profile_800x621.jpg
// module id = V2AE
// module chunks = 0